import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/shared/Sidebar';
import TopBar from '../components/shared/TopBar';
import { LayoutDashboard, Users2, ShieldCheck, Home, CalendarDays, UserRound, MessageSquare } from 'lucide-react';

const groups = [
  { label: 'Operations', items: [
    { to: '/admin/dashboard', label: 'Dashboard', icon: LayoutDashboard, end: true },
    { to: '/admin/properties', label: 'Properties', icon: Home },
    { to: '/admin/bookings', label: 'Bookings', icon: CalendarDays },
    { to: '/admin/messages', label: 'Messages', icon: MessageSquare },
  ]},
  { label: 'People', items: [
    { to: '/admin/hosts', label: 'Hosts', icon: Users2 },
    { to: '/admin/customers', label: 'Customers', icon: UserRound },
    { to: '/admin/admin-users', label: 'Admin users', icon: ShieldCheck },
  ]},
];

export default function AdminLayout() {
  return (
    <div className="min-h-screen bg-slate-50/60 flex">
      <Sidebar brand="StayEasy" badge="Admin Console" groups={groups} />
      <div className="flex-1 min-w-0 flex flex-col">
        <TopBar admin />
        <main className="flex-1 px-6 md:px-8 py-7 animate-fade-in">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
